import { type CountryCallingCode, type CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

import { env as configEnv } from "@/config";

export const DEFAULT_COUNTRY_CODE = "US";

export const validatePhoneNumber = (
    mdn: string | undefined,
    defaultCountry: CountryCode = DEFAULT_COUNTRY_CODE,
    skipValidation: boolean = false,
): { valid: boolean; number?: string; countryCode?: CountryCallingCode } => {
    if (!mdn) {
        return { valid: false };
    }
    const parsed = mdn.startsWith("+")
        ? parsePhoneNumberFromString(mdn)
        : parsePhoneNumberFromString(mdn, { defaultCountry });
    if (!parsed) {
        return { valid: false };
    }
    const isValid = configEnv.isProdMode && !skipValidation ? parsed.isValid() : parsed.isPossible();
    return { valid: isValid, number: parsed.number, countryCode: parsed.countryCallingCode };
};

export const isInternationalCaller = (mdn: string): boolean => {
    const parsed = parsePhoneNumberFromString(mdn);
    if (!parsed) {
        return false;
    }
    return parsed.country !== "US";
};
